module.exports = __webpack_public_path__ + "static/media/jcb.4aaa3383.svg";